import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, computed, onMounted } from 'vue';
import InputRow from '@/components/Form/InputRow.vue';
import { validationLimitingValue } from '@/constants';
const lc = 'views.worker_management.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PrivateInfo',
    props: {
        workerDetail: { default: () => ({}) },
        formRules: { default: () => ({}) },
        headCol: { default: 3 }
    },
    emits: ["setFormData", "setOriginData"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { CAR_NUMBER_MAX_LENGTH } = validationLimitingValue;
        const formData = ref({
            carNumber: props.workerDetail.carNumber,
        });
        const updateFormData = ref({});
        const carNumber = computed({
            get() {
                return updateFormData.value.carNumber;
            },
            set(value) {
                updateFormData.value.carNumber = value;
                emit('setFormData', updateFormData.value);
            },
        });
        onMounted(() => {
            Object.assign(updateFormData.value, formData.value);
            emit('setOriginData', formData.value);
            emit('setFormData', updateFormData.value);
        });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            return (_openBlock(), _createElementBlock("div", null, [
                _createCommentVNode(" 차량번호 "),
                _createVNode(InputRow, {
                    "data-cy": "worker-car-number-input-row",
                    label: _ctx.$t(`${lc}car_number`),
                    "head-col": props.headCol
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            modelValue: carNumber.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((carNumber).value = $event)),
                            density: "compact",
                            variant: "outlined",
                            "hide-details": "auto",
                            "validate-on": "blur",
                            placeholder: _ctx.$t('common.input_field_placeholder', { field: '차량번호' }),
                            rules: _ctx.formRules.carNumber,
                            maxlength: _unref(CAR_NUMBER_MAX_LENGTH)
                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "rules", "maxlength"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"])
            ]));
        };
    }
});
